import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import StrategyPanel from "../components/StrategyPanel";
import { ArrowLeft } from "lucide-react";

export default function ClientStrategy() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  useEffect(()=>{ (async ()=>{
    const { data } = await api.get(`/clients/${id}`);
    setClient(data);
  })(); }, [id]);

  return (
    <div className="p-6 md:p-8 space-y-6 max-w-[1400px]">
      <Link to={`/clients/${id}`} className="inline-flex items-center gap-2 text-xs font-mono uppercase text-neutral-600 hover:text-neutral-800"><ArrowLeft className="w-3 h-3"/> Back to Client</Link>
      <div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">The Playbook</div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Social Media Strategy</h1>
        <p className="text-neutral-600 text-sm mt-1">{client?.client_name || "…"} · Written by the strategist, followed by the whole team.</p>
      </div>
      <StrategyPanel clientId={id} clientName={client?.client_name}/>
    </div>
  );
}
